'use client';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function TeamPage() {
  return (
    <>
      <Header />
      <main className="min-h-screen bg-[#0A0A0A] text-white pt-24">

        {/* Hero */}
        <section className="py-32 px-6 border-b border-white/10">
          <div className="max-w-[1200px] mx-auto text-center">
            <span className="text-[10px] uppercase tracking-[0.25em] text-[#DC2626] block mb-8">
              The Team
            </span>
            <h1 className="text-5xl lg:text-7xl font-bold tracking-tight mb-8 leading-[1.05]">
              Built by operators.<br />Expanding with purpose.
            </h1>
            <div className="w-16 h-[1px] bg-[#DC2626] mx-auto mb-10" />
            <p className="text-xl text-gray-400 max-w-2xl mx-auto leading-relaxed font-light">
              Best Odds Corp is founder-led today. As the business grows, this page will introduce the operators, collaborators, and specialists who make the work happen.
            </p>
          </div>
        </section>

        {/* Current State */}
        <section className="py-28 px-6 border-b border-white/10">
          <div className="max-w-[900px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
              <div>
                <span className="text-[10px] uppercase tracking-[0.25em] text-[#DC2626] block mb-6">
                  Right Now
                </span>
                <h2 className="text-3xl lg:text-4xl font-bold tracking-tight mb-8 leading-tight">
                  Founder-led.<br />Intentionally lean.
                </h2>
                <p className="text-body text-gray-400 leading-relaxed mb-6">
                  Every engagement is led directly by Daniel Moravec. No account managers. No junior handoffs. The person you talk to is the person doing the work.
                </p>
                <p className="text-body text-gray-400 leading-relaxed mb-10">
                  When specialized execution is needed, Best Odds works with a trusted network of collaborators — vetted for quality, not volume.
                </p>
                <Link href="/work-with-daniel">
                  <button className="px-8 py-4 bg-[#DC2626] text-white text-[10px] uppercase tracking-widest font-semibold hover:bg-[#b91c1c] transition-colors">
                    Meet Daniel
                  </button>
                </Link>
              </div>

              <div className="space-y-4">
                {[
                  { icon: 'UserIcon', label: 'Direct founder access on every engagement' },
                  { icon: 'BoltIcon', label: 'Sprint-based execution — no bloated teams' },
                  { icon: 'CpuChipIcon', label: 'AI leverage replaces headcount where possible' },
                  { icon: 'ShieldCheckIcon', label: 'Trusted collaborator network for specialized work' },
                ].map((item, idx) => (
                  <div key={idx} className="flex items-start gap-5 p-6 border border-zinc-800">
                    <Icon name={item.icon as any} size={18} className="text-[#DC2626] mt-0.5 flex-shrink-0" />
                    <span className="text-body-sm text-gray-300">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Coming Soon Placeholder */}
        <section className="py-28 px-6 border-b border-white/10 bg-[#0D0D0D]">
          <div className="max-w-[1200px] mx-auto text-center">
            <span className="text-[10px] uppercase tracking-[0.25em] text-[#DC2626] block mb-8">
              Coming Soon
            </span>
            <h2 className="text-3xl lg:text-4xl font-bold tracking-tight mb-6">
              Full team profiles — coming as we grow
            </h2>
            <p className="text-body text-gray-400 max-w-xl mx-auto mb-16 leading-relaxed">
              This page will showcase the people behind Best Odds Corp as the team expands. Check back as we build.
            </p>

            {/* Placeholder cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-3xl mx-auto">
              {[1, 2, 3].map((i) => (
                <div key={i} className="border border-zinc-800 p-10 flex flex-col items-center gap-4 opacity-30">
                  <div className="w-16 h-16 border border-white/20 flex items-center justify-center">
                    <Icon name="UserIcon" size={28} className="text-white/40" />
                  </div>
                  <div className="w-24 h-2 bg-white/10" />
                  <div className="w-16 h-1.5 bg-white/8" />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-28 px-6">
          <div className="max-w-[1200px] mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-bold tracking-tight mb-6">
              Want to work with us?
            </h2>
            <p className="text-body text-gray-400 max-w-xl mx-auto mb-10 leading-relaxed">
              Start with a Sprint or reach out to explore how Best Odds Corp can support your business.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link href="/book">
                <button className="px-10 py-4 bg-[#DC2626] text-white text-[10px] uppercase tracking-widest font-semibold hover:bg-[#b91c1c] transition-colors">
                  Book a Sprint
                </button>
              </Link>
              <Link href="/contact">
                <button className="px-10 py-4 border border-white/20 text-white text-[10px] uppercase tracking-widest font-semibold hover:border-white/50 transition-colors">
                  Get in Touch
                </button>
              </Link>
            </div>
          </div>
        </section>

      </main>
      <Footer />
    </>
  );
}